module.exports = __webpack_public_path__ + "static/img/10.faa4259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/10.png
// module id = SEPs
// module chunks = 0